import { render, staticRenderFns } from "./SelecionaAgenda.vue?vue&type=template&id=265d2953"
import script from "./SelecionaAgenda.vue?vue&type=script&lang=js"
export * from "./SelecionaAgenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports